import React from 'react';
import { UsersIcon, TrendingUpIcon, TrendingDownIcon } from 'lucide-react';
export function PerformanceDistribution() {
  return <div className="bg-slate-800 border border-slate-700 rounded-lg p-6 h-full" data-id="element-63">
      <div className="flex items-center justify-between mb-6" data-id="element-64">
        <h3 className="text-lg font-semibold text-white flex items-center gap-2" data-id="element-65">
          <UsersIcon className="w-5 h-5 text-blue-400" data-id="element-66" />
          Performance Distribution
        </h3>
        <span className="text-xs text-slate-400 bg-slate-700/50 px-2 py-1 rounded" data-id="element-67">
          Last 30 Days
        </span>
      </div>

      {/* Tier Breakdown */}
      <div className="mb-8" data-id="element-68">
        <div className="flex justify-between text-sm text-slate-400 mb-2" data-id="element-69">
          <span data-id="element-70">Tier Breakdown (A/B/C)</span>
          <span data-id="element-71">Total LOs: 42</span>
        </div>

        {/* Visual Stacked Bar */}
        <div className="flex w-full h-4 rounded-full overflow-hidden mb-3" data-id="element-72">
          <div className="bg-emerald-500 w-[20%]" title="Tier A: 20%" data-id="element-73" />
          <div className="bg-blue-500 w-[50%]" title="Tier B: 50%" data-id="element-74" />
          <div className="bg-amber-500 w-[30%]" title="Tier C: 30%" data-id="element-75" />
        </div>

        {/* Legend / Stats */}
        <div className="grid grid-cols-3 gap-4 text-center" data-id="element-76">
          <div className="bg-slate-700/30 rounded p-2 border border-slate-700/50" data-id="element-77">
            <div className="text-emerald-400 font-bold text-lg" data-id="element-78">8</div>
            <div className="text-xs text-slate-400" data-id="element-79">Tier A (Top)</div>
            <div className="text-xs text-emerald-500/80 mt-1" data-id="element-80">19%</div>
          </div>
          <div className="bg-slate-700/30 rounded p-2 border border-slate-700/50" data-id="element-81">
            <div className="text-blue-400 font-bold text-lg" data-id="element-82">21</div>
            <div className="text-xs text-slate-400" data-id="element-83">Tier B (Core)</div>
            <div className="text-xs text-blue-500/80 mt-1" data-id="element-84">50%</div>
          </div>
          <div className="bg-slate-700/30 rounded p-2 border border-slate-700/50" data-id="element-85">
            <div className="text-amber-400 font-bold text-lg" data-id="element-86">13</div>
            <div className="text-xs text-slate-400" data-id="element-87">Tier C (Risk)</div>
            <div className="text-xs text-amber-500/80 mt-1" data-id="element-88">31%</div>
          </div>
        </div>
      </div>

      {/* Comparison Stats */}
      <div className="space-y-4" data-id="element-89">
        <h4 className="text-sm font-medium text-slate-300 border-b border-slate-700 pb-2" data-id="element-90">
          Efficiency Metrics
        </h4>

        <div className="flex items-center justify-between" data-id="element-91">
          <div className="flex items-center gap-3" data-id="element-92">
            <div className="p-2 bg-emerald-500/10 rounded-lg" data-id="element-93">
              <TrendingUpIcon className="w-5 h-5 text-emerald-400" data-id="element-94" />
            </div>
            <div data-id="element-95">
              <p className="text-sm text-slate-400" data-id="element-96">Top 20% Avg Funded</p>
              <p className="text-lg font-bold text-white" data-id="element-97">$4.2M</p>
            </div>
          </div>
          <div className="text-right" data-id="element-98">
            <span className="text-xs text-emerald-400 bg-emerald-500/10 px-2 py-1 rounded" data-id="element-99">
              +12% vs last mo
            </span>
          </div>
        </div>

        <div className="flex items-center justify-between" data-id="element-100">
          <div className="flex items-center gap-3" data-id="element-101">
            <div className="p-2 bg-rose-500/10 rounded-lg" data-id="element-102">
              <TrendingDownIcon className="w-5 h-5 text-rose-400" data-id="element-103" />
            </div>
            <div data-id="element-104">
              <p className="text-sm text-slate-400" data-id="element-105">Bottom 20% Avg Funded</p>
              <p className="text-lg font-bold text-white" data-id="element-106">$850k</p>
            </div>
          </div>
          <div className="text-right" data-id="element-107">
            <span className="text-xs text-rose-400 bg-rose-500/10 px-2 py-1 rounded" data-id="element-108">
              -5% vs last mo
            </span>
          </div>
        </div>

        <div className="pt-2 mt-2 border-t border-slate-700" data-id="element-109">
          <div className="flex justify-between items-center" data-id="element-110">
            <span className="text-sm text-slate-400" data-id="element-111">Team Conversion Avg</span>
            <span className="text-lg font-bold text-blue-400" data-id="element-112">32.4%</span>
          </div>
          <div className="w-full bg-slate-700 h-1.5 rounded-full mt-2" data-id="element-113">
            <div className="bg-blue-500 h-1.5 rounded-full w-[32.4%]" data-id="element-114" />
          </div>
        </div>
      </div>
    </div>;
}